let nbjours = 0;
let demis = 0;
let vingtQuatre = 0;
let semaine = 0;
let bimensuel = 0;


export default function calculDuree(ridingPeriod) {
  
    let d1 = ridingPeriod[0][0];
    let d2 = ridingPeriod[0][1];
    let h1 = ridingPeriod[1][0];
    let h2 = ridingPeriod[1][1];

    nbjours = ecartJours(d1, d2);
    demis = demiJournee(h1, h2);
    vingtQuatre = forfait24(d1,d2,h1,h2);

    if(nbjours>=0 && demis === 2) //convertire 2 demis à la meme date en forfait jour
    {
        nbjours+=1;
        demis=0;
    }

    if (parseInt(h1)>=14 && parseInt(h2)<=14) //cas des 2 demi journées soir - matin
    {
      if(nbjours===1 && parseInt(h1)>17 && parseInt(h2)===9){
        demis=1;
        nbjours=0;
    }

    else{

        if (nbjours>0 && nbjours<5) {
            demis=2;
            nbjours-=1;
        }
    }
  }

    if(vingtQuatre){ //forfait 24h non cumulable
        nbjours = 0;
        demis = 0;
    }

    
    semaine = Math.trunc(parseInt(nbjours) / 7); //semaine de 7 jours, du samedi au samedi inclus
    
    nbjours = parseInt(nbjours)%7; //une fois retiré le multiple de 7 des semaines, on recupere le nb de jours de la semaine non complète
    nbjours = (parseInt(nbjours)===1 && parseInt(semaine) >=1)?0:nbjours; // on gère le cas du samedi au samedi 
    if(parseInt(semaine)>=1 && parseInt(nbjours)===7)
    {
      semaine +=1;
      nbjours = 0;
    }

    bimensuel = Math.trunc(parseInt(semaine) / 2);
    semaine -= bimensuel*2;
    
    return {vingtQuatre:vingtQuatre,demi:demis,jour:nbjours,semaine:semaine,bimensuel:bimensuel}



  
}



export function prepareDureeTexte(dureeObject) {

  let prompt = ""
  prompt = (dureeObject.bimensuel > 0) ? dureeObject.bimensuel + "x forfait 2 semaines" : "";

  prompt += (prompt !== "" && dureeObject.semaine > 0) ? " + " : "";

  prompt += (dureeObject.semaine > 0) ? dureeObject.semaine + " semaine" : "";
  prompt += (dureeObject.semaine > 1) ? "s " : "";

  prompt += (prompt !== "" && dureeObject.jour > 0) ? " + " : "";

  prompt += (dureeObject.jour > 0) ? dureeObject.jour + " jour" : "";
  prompt += (dureeObject.jour > 1) ? "s " : "";

  prompt += (prompt !== "" && dureeObject.demi > 0) ? " + " : "";

  prompt += (dureeObject.demi > 0) ? dureeObject.demi + " demi-journée" : "";
  prompt += (dureeObject.demi > 1) ? "s " : "";

  prompt += (dureeObject.vingtQuatre > 0) ? dureeObject.vingtQuatre + " forfait 24H" : "";
  prompt += (prompt === "") ? "" : ".";

  return prompt;
}



function ecartJours(jour1, jour2) {
  let j1 = new Date(jour1);
  let j2 = new Date(jour2);
  let diff = j2.getTime() - j1.getTime();
  let daydiff = diff / (1000 * 60 * 60 * 24);
  return daydiff;
}

function demiJournee(debut, fin) {
  let qte = 0;
  if (debut < 13) {
    qte = fin > 13 ? 2 : 1;
  } else {
    qte = 1;
  }

  return qte;
}

function forfait24(d1,d2,h1,h2)
{
    let qte=0;
    if (ecartJours(d1,d2) === 1 && h1 === h2)
    {qte=1;}
    else
    {qte=0;}

    return qte;

}